<template>
    <div class="section" id="section-equipe">
        <div class="section-content">
            <div v-if="!loaded" class="container_preload">
                <div class="roulette"></div>
            </div>
            <div v-else-if="loaded">
                <div class="section-content-banner">
                    <div>&Eacute;QUIPE</div>
                    <div>outils</div>
                    <div class="closer fermer" @click="closeFooter()">╳</div>
                </div>
                <div class="section-content-loaded">
                    <div v-html="contenu"></div>
                </div>
            </div>
        </div>
    </div>
    <!-- <div class="contenu_volet_bas">
        <div v-if="!loaded" class="container_preload">
            <div class="roulette"></div>
        </div>
        <div v-html="contenu" v-else-if="loaded"></div>
    </div> -->
</template>

<script>

import { url_annexes } from '../../variables.js'

export default {
    data() {
        return {
            loaded:false,
            contenu:""
        }
    },

    mounted: function() {
        this.axios.get(url_annexes+"equipe").then((response) => {
            this.contenu = response.data.contenu;
            this.loaded = true;
        });
    },
    methods : {
        closeFooter(){
            console.log(this);
            document.body.setAttribute("data-footer",false);
            document.body.setAttribute("data-mode","");
        }
    }
};
</script>
<style>



</style>